export default __webpack_public_path__ + "end-device.2e0b0021569590a97edd.svg";